import { Link } from "react-router-dom";

export default function ListingHero({
  siteLabel = "iLearnings",
  badge = "Learn · Build · Grow",
  headlinePrefix = "Welcome to",
  description,
  primaryStat,
  primaryStatLabel,
  secondaryStat,
  secondaryStatLabel,
  primaryCtaTo = "/",
  primaryCtaLabel = "",
  secondaryCtaTo = "/tutorialseries",
  secondaryCtaLabel = "",
}) {
  const showPrimaryStat =
    primaryStat !== null &&
    primaryStat !== undefined &&
    primaryStat !== "" &&
    primaryStatLabel;

  const showSecondaryStat =
    secondaryStat !== null &&
    secondaryStat !== undefined &&
    secondaryStat !== "" &&
    secondaryStatLabel;

  return (
    <section className="home-hero home-hero--compact mt-2" data-aos="fade-up">
      <div className="home-hero__inner">
        <span className="home-hero__badge">{badge}</span>

        <h1 className="home-hero__title">
          {headlinePrefix}{" "}
          <span className="home-hero__accent">{siteLabel}</span>
        </h1>

        {description ? <p className="home-hero__lead">{description}</p> : null}

        {(showPrimaryStat || showSecondaryStat) && (
          <div className="home-hero__stats">
            {showPrimaryStat && (
              <div className="home-hero__stat">
                <span className="home-hero__stat-value">{primaryStat}</span>
                <span className="home-hero__stat-label">
                  {primaryStatLabel}
                </span>
              </div>
            )}

            {showSecondaryStat && (
              <div className="home-hero__stat">
                <span className="home-hero__stat-value">{secondaryStat}</span>
                <span className="home-hero__stat-label">
                  {secondaryStatLabel}
                </span>
              </div>
            )}
          </div>
        )}

        {(primaryCtaLabel || secondaryCtaLabel) && (
          <div className="home-hero__actions">
            {primaryCtaLabel && (
              <Link to={primaryCtaTo} className="home-hero__btn-ghost px-4">
                {primaryCtaLabel}
              </Link>
            )}

            {secondaryCtaLabel && (
              <Link to={secondaryCtaTo} className="home-hero__btn-ghost">
                {secondaryCtaLabel}
              </Link>
            )}
          </div>
        )}
      </div>
    </section>
  );
}
